import React from 'react'
import {
  Create,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useTranslate,
  BooleanInput,
  SelectArrayInput,
  FormDataConsumer,
} from 'react-admin'

import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { isJsonValidate } from 'src/helper/validatorJson'
import { TimePickerViews } from 'src/components/uiElements/react-hook-fields/TimePicker'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import { Days } from 'src/components/pages/payment/payment-type/logic/days'
export const PaymentTypeCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.payment-type') },
    })
    redirect('/payment-type')
  }

  const onError = () => {
    notify('ra.notification.created_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.payment-type') },
    })
  }
  dayjs.extend(utc);
  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.create_payment_type')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.short_name')} required>
              <TextInput source='short_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.long_name')} required>
              <TextInput source='long_name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.config')}>
              <TextInput
                source='config'
                label=''
                fullWidth
                multiline
                validate={isJsonValidate}
                format={(v) => {
                  return JSON.stringify(v ? v : undefined)
                }}
                parse={(v) => {
                  try {
                    if (v.length >= 2) {
                      return JSON.parse(v)
                    }
                  } catch (e) {
                    notify('ra.field.invalid_json', { type: 'error' })
                    return undefined
                  }
                }}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.ref_table_detail')}>
              <TextInput source='ref_table_detail' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.ref_site')} tooltiptext={translate('ra.message.ref_site')}>
              <TextInput source='ref_site' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.state')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.code')}>
              <TextInput source='code' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.active_days')}>
              <SelectArrayInput source='active_days' label={false} fullWidth choices={Days} />
            </EditInputsWrap>

            <EditInputsWrap label={translate('ra.field.active_hours_from')}>
              <TimePickerViews source='active_hours_from' />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.active_hours_to')}>
              <FormDataConsumer>
                {({ formData }) => {
                  return (
                    <TimePickerViews
                      minTime={
                        formData.active_hours_from ? dayjs(formData.active_hours_from).utc().add(5, 'minute') : null
                      }
                      disabled={!formData.active_hours_from}
                      source='active_hours_to'
                      isNull={!formData.active_hours_from}
                    />
                  )
                }}
              </FormDataConsumer>
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
